import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import MySelect from '../../components/MySelect';
import { Bs7Circle, BsFillBuildingFill } from 'react-icons/bs';
import { GrWorkshop } from 'react-icons/gr';

const EditEnseignant = ({ updatedEnseignant, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken, user } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [etat, setEtat] = useState([
      {
        id:1,
        libelle:'Actif'
      },
      {
        id:0,
        libelle:'Inactif'
      }
    ]);
    const [selectedEtat, setSelectedEtat] = useState(etat.filter((item) => item.id === updatedEnseignant.etat));
    const [inputValueEtat, setValueEtat] = useState('');

    const [enseignant, setEnseignant] = useState({
        id:updatedEnseignant.id,
        etat: updatedEnseignant.etat,
        nom: updatedEnseignant.nom,
        tel: updatedEnseignant.tel,
        nni: updatedEnseignant.nni,
        adresse:updatedEnseignant.adresse,
        montantHours:updatedEnseignant.montantHours

    });

    const handleInputChangeEtat = value => {
        setValueEtat(value);
    };



    // handle selection


    // handle selection
    const handleChangeEtat = value => {
        setSelectedEtat(value);
        setEnseignant({ ...enseignant, etat: value.id });

    }


    const navigate = useNavigate();


    
    useEffect(() => {
        
    }, []);
    const onSubmit = () => {
        setErrors(null);
        setLoading(true);
        axiosClient.put('/enseignant', enseignant)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col max-h-screen overflow-auto  bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto md:w-1/3 lg:w-1/3 xl:w-1/3 rounded-xl'>
                        <div className=''>
                            <Header icon={<GrWorkshop />} title="Modifier un enseignant" titleAr="تعديل المعلم" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                <div className='flex-col w-full justify-evenly '>
                                <MySelect label="Etat" labelAr="الوضعية" className='mt-2 outline-1 ' placeholder="Etat" cacheOptions defaultOptions value={selectedEtat} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={etat} onInputChange={handleInputChangeEtat} onChange={handleChangeEtat} />
                                    <div className='mr-2'>
                                        <Input label="Nom" labelAr="الإسم" type="text" value={enseignant.nom} onChange={ev => setEnseignant({ ...enseignant, nom: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input  label="Tel" labelAr="الهاتف" type="text" value={enseignant.tel} onChange={ev => setEnseignant({ ...enseignant, tel: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Montant / heure" labelAr="المبلغ / الساعة" type="text" value={enseignant.montantHours} onChange={ev => setEnseignant({ ...enseignant, montantHours: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="NNI" labelAr="الرقم الوطني" type="text" value={enseignant.nni} onChange={ev => setEnseignant({ ...enseignant, nni: ev.target.value })}  />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Adresse" labelAr="العنوان" type="text" value={enseignant.adresse} onChange={ev => setEnseignant({ ...enseignant, adresse: ev.target.value })}  />
                                    </div>
                                </div>
                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />

                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditEnseignant